import React from 'react';

/* What a reply answers, shown above it. Click to jump to the original. */
export function ReplyQuote({ q }) {
  if (!q) return null;
  if (q.deleted) return <div className="reply-quote deleted">Original message was deleted</div>;
  const jump = () => {
    const el = document.getElementById(`msg-${q.id}`);
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    el.classList.add('flash');
    setTimeout(() => el.classList.remove('flash'), 1600);
  };
  return (
    <button type="button" className="reply-quote" onClick={jump} title="Show the original">
      <b>{q.author}</b> <span>{q.snippet}</span>
    </button>
  );
}

/* Above the box while you're writing a reply. */
export function ReplyingTo({ to, onCancel }) {
  if (!to) return null;
  return (
    <div className="replying-to">
      <span>Replying to <b>{to.author?.name || 'a member'}</b>: {(to.body || '').replace(/\s+/g, ' ').slice(0, 90)}</span>
      <button type="button" className="linklike" aria-label="Cancel reply" onClick={onCancel}>×</button>
    </div>
  );
}
